module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }